import React from 'react'
import PointsOverview from '@/components/PointsOverview'

/**
 * Points page - Shows leaderboard and points overview
 * Route: /dashboard/points
 */
export const PointsPage: React.FC = () => {
  return <PointsOverview />
}
